"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  createGuestApiClient: () => createGuestApiClient,
  schemas: () => schemas
});
module.exports = __toCommonJS(src_exports);
var import_core = require("@zodios/core");
var import_zod = require("zod");
var OkResponseDto = import_zod.z.object({ success: import_zod.z.literal(true) });
var GetGuestConsentsResponseDto = import_zod.z.object({
  guestId: import_zod.z.string(),
  consents: import_zod.z.array(
    import_zod.z.object({ type: import_zod.z.enum(["general-terms", "marketing", "first-party", "process-and-store-id-documents"]) })
  ),
  email: import_zod.z.string().email(),
  firstName: import_zod.z.string().optional(),
  lastName: import_zod.z.string().optional()
});
var PostGuestConsentsRequestDto = import_zod.z.object({
  consents: import_zod.z.array(
    import_zod.z.object({ type: import_zod.z.enum(["general-terms", "marketing", "first-party", "process-and-store-id-documents"]) })
  ),
  confirmationHost: import_zod.z.string().optional(),
  shouldDelayConfirmation: import_zod.z.boolean().optional(),
  preferredLanguage: import_zod.z.string().optional(),
  firstName: import_zod.z.string().optional(),
  lastName: import_zod.z.string().optional()
});
var PostGuestConsentsResponseDto = import_zod.z.object({
  guestId: import_zod.z.string(),
  consents: import_zod.z.array(
    import_zod.z.object({ type: import_zod.z.enum(["general-terms", "marketing", "first-party", "process-and-store-id-documents"]) })
  ),
  email: import_zod.z.string().email(),
  firstName: import_zod.z.string().optional(),
  lastName: import_zod.z.string().optional()
});
var ConfirmGuestConsentsResponseDto = import_zod.z.object({ guestId: import_zod.z.string() });
var ErrorResponseDto = import_zod.z.object({ success: import_zod.z.literal(false), message: import_zod.z.unknown().nullish() });
var ConsentDto = import_zod.z.object({
  type: import_zod.z.enum(["general-terms", "marketing", "first-party", "process-and-store-id-documents"])
});
var schemas = {
  OkResponseDto,
  GetGuestConsentsResponseDto,
  PostGuestConsentsRequestDto,
  PostGuestConsentsResponseDto,
  ConfirmGuestConsentsResponseDto,
  ErrorResponseDto,
  ConsentDto
};
var endpoints = (0, import_core.makeApi)([
  {
    method: "get",
    path: "/guests/v1/consents/:email",
    alias: "getGuestConsents",
    requestFormat: "json",
    parameters: [
      {
        name: "email",
        type: "Path",
        schema: import_zod.z.string()
      }
    ],
    response: OkResponseDto.and(import_zod.z.object({ data: GetGuestConsentsResponseDto })),
    errors: [
      {
        status: 404,
        description: `Guest not found`,
        schema: import_zod.z.void()
      }
    ]
  },
  {
    method: "post",
    path: "/guests/v1/consents/:email",
    alias: "postGuestConsents",
    requestFormat: "json",
    parameters: [
      {
        name: "body",
        type: "Body",
        schema: PostGuestConsentsRequestDto
      },
      {
        name: "email",
        type: "Path",
        schema: import_zod.z.string()
      }
    ],
    response: OkResponseDto.and(import_zod.z.object({ data: PostGuestConsentsResponseDto })),
    errors: [
      {
        status: 400,
        description: `Invalid consents`,
        schema: import_zod.z.void()
      }
    ]
  },
  {
    method: "post",
    path: "/guests/v1/consents/:email/confirm",
    alias: "confirmGuestConsents",
    requestFormat: "json",
    parameters: [
      {
        name: "email",
        type: "Path",
        schema: import_zod.z.string()
      }
    ],
    response: OkResponseDto.and(import_zod.z.object({ data: ConfirmGuestConsentsResponseDto })),
    errors: [
      {
        status: 400,
        description: `Invalid consents`,
        schema: import_zod.z.void()
      },
      {
        status: 404,
        description: `Guest not found`,
        schema: import_zod.z.void()
      }
    ]
  }
]);
var createGuestApiClient = (baseUrl, options) => {
  return new import_core.Zodios(baseUrl, endpoints, options);
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  createGuestApiClient,
  schemas
});
